import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";

const WHATSAPP_NUMBER = "40723886688"; // International format without +
const PHONE_DISPLAY = "0723 88 66 88";

const WhatsAppButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(timer);
    // Mount-once reveal timer, no dependencies required
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const message = encodeURIComponent("Bună! Aș dori informații despre cursurile BIU BIU DRIVING.");
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${message}`;

  return (
    <div
      data-testid="whatsapp-float"
      className={`fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-50 flex items-end gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      {showTooltip && (
        <div className="hidden sm:flex bg-white rounded-2xl shadow-2xl border border-brand-border-soft p-4 pr-10 max-w-[260px] relative animate-in fade-in slide-in-from-right-4">
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute top-2 right-2 text-brand-muted hover:text-brand-navy"
            aria-label="Închide"
            data-testid="whatsapp-tooltip-close"
          >
            <X className="w-4 h-4" />
          </button>
          <div>
            <p className="font-display font-bold text-brand-navy text-sm">Scrie-ne pe WhatsApp</p>
            <p className="text-xs text-brand-muted mt-1 leading-relaxed">
              Răspundem rapid. Trimite mesaj la {PHONE_DISPLAY}.
            </p>
          </div>
        </div>
      )}

      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-btn"
        onMouseEnter={() => setShowTooltip(true)}
        onFocus={() => setShowTooltip(true)}
        className="relative w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white flex items-center justify-center shadow-2xl hover:scale-110 transition-all"
        aria-label="Contactează-ne pe WhatsApp"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="currentColor"
          className="relative w-7 h-7 sm:w-8 sm:h-8"
        >
          <path d="M20.52 3.48A11.93 11.93 0 0 0 12.04 0C5.5 0 .18 5.32.18 11.86c0 2.09.55 4.13 1.59 5.93L0 24l6.4-1.67a11.85 11.85 0 0 0 5.64 1.44h.01c6.55 0 11.86-5.32 11.86-11.86 0-3.17-1.23-6.15-3.39-8.43zM12.05 21.7h-.01a9.84 9.84 0 0 1-5.01-1.37l-.36-.21-3.8.99 1.02-3.7-.24-.38a9.85 9.85 0 0 1-1.51-5.18c0-5.44 4.42-9.86 9.86-9.86 2.63 0 5.11 1.03 6.97 2.89a9.78 9.78 0 0 1 2.89 6.98c0 5.44-4.43 9.84-9.81 9.84zm5.41-7.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.47-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.49 1.07 2.89 1.22 3.09c.15.2 2.11 3.22 5.11 4.51.71.31 1.27.49 1.71.63.72.23 1.37.2 1.89.12.58-.09 1.76-.72 2.01-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35z" />
        </svg>
      </a>
    </div>
  );
};

export default WhatsAppButton;
